export const leasingFormDoneFromLK = () => {
  typeof window.ym !== 'undefined'
    ? window.ym(30430687, 'reachGoal', '2025LeasingFormDoneFromLK')
    : console.log('Метрика не инициализирована - нажатие ПОДАТЬ ЗАЯВКУ');
};

export const leasingFormLK = () => {
  typeof window.ym !== 'undefined'
    ? window.ym(30430687, 'reachGoal', '2025LeasingFormLK')
    : console.log('Метрика не инициализирована - нажатие Создать новую заявку');
};

export const leasingFormGoToTID = () => {
  typeof window.ym !== 'undefined'
    ? window.ym(30430687, 'reachGoal', '2025LeasingFormGoToTID')
    : console.log('Метрика не инициализирована - нажатие Создать новую заявку');
};

export const leasingFormGoToLK = () => {
  typeof window.ym !== 'undefined'
    ? window.ym(30430687, 'reachGoal', '2025LeasingFormGoToLK')
    : console.log('Метрика не инициализирована');
};

export const leasingFormGoToTid = () => {
  typeof window.ym !== 'undefined'
    ? window.ym(30430687, 'reachGoal', '2025LeasingFormGoToTID')
    : console.log('Метрика не инициализирована');
};

export const leasingFormLoadFullForm = () => {
  typeof window.ym !== 'undefined'
    ? window.ym(30430687, 'reachGoal', '2025LeasingFormLoadFullForm')
    : console.log('Метрика не инициализирована');
};

export const creatingAnAccount = () => {
  typeof window.ym !== 'undefined'
    ? window.ym(98862652, 'reachGoal', 'Creating an account')
    : console.log('Метрика не инициализирована');
};

export const creatingReconciliationReport = () => {
  typeof window.ym !== 'undefined'
    ? window.ym(98862652, 'reachGoal', 'Creating a Reconciliation Report')
    : console.log('Метрика не инициализирована');
};

export const leasingFormDoneFromTID = () => {
  // TODO Разобраться где эта метрика и нужна ли
  console.log('Метрика утрачена или удалена');
}